module.exports = __webpack_public_path__ + "img/guozai_07.4d227247.jpg";